import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
// import "../SingleHotelCard/SingleHotelCard.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import imgNotFound from "../../../assets/images/single-image.png";
import moment from "moment";
import {
  calculateLOS,
  currentDateSingle,
  formatIndianCurrency,
} from "../../../utils/utils";
import RoomGetQuotePopup from "../../NewSendEnquiryPopup/RoomGetQuotePopup";
import styles from "./HotelCard.module.scss";
import NewSingleQueryPopup from "../../NewSendEnquiryPopup/NewSingleQueryPopup";

function NewUISingleHotelRoomCard({ rooms, bookingData }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [showRoomGetQuotePopup, setShowRoomGetQuotePopup] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [roomId, setRoomId] = useState(null);
  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [noOfNights, setNoOfNights] = useState("");

  const [markupData, setMarkupData] = useState([]);
  const [roomRatesData, setRoomRatesData] = useState(null);

  const userToken = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");
  const [commission, setCommission] = useState({});

  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");

  const [selectedDiscount, setSelectedDiscount] = useState([]);
  const [selectedAutomaticDiscount, setSelectedAutomaticDiscount] = useState(
    []
  );
  const [propertyDiscountArray, setPropertyDiscountArray] = useState([]);

  const {
    item: selectedPlan,
    hotelData,
    ratesData,
    room_id,
  } = location?.state || {};
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const bookingDiscount = 0; // replace with actual value
  const bookingDiscountType = "percentage"; // replace with actual value
  const agentDiscount = userDetails?.agent_category_discount || 0;
  const agentDiscountType = userDetails?.agent_discount_type || "percentage";

  const [pricePopUpId, setPricePopUpId] = useState(false);
  const [isPopupVisibleId, setIsPopupVisibleId] = useState(null);
  const openPopup = (id) => {
    setIsPopupVisibleId(id);
  };

  const [priceDetail, setPriceDetail] = useState({});

  useEffect(() => {
    if (!bookingData) {
      navigate("/");
    }

    const calculateNoOfNights = () => {
      if (!bookingData.checkinYear) navigate("/");
      const checkin = new Date(
        bookingData.checkinYear,
        bookingData.checkinMonth - 1,
        bookingData.checkinDay
      );
      const checkout = new Date(
        bookingData.checkoutYear,
        bookingData.checkoutMonth - 1,
        bookingData.checkoutDay
      );
      const diffTime = Math.abs(checkout - checkin);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setNoOfNights(diffDays);
    };

    const formatDate = (year, month, day) => {
      return `${year}-${month}-${day}`;
    };

    if (bookingData) {
      calculateNoOfNights();
      setCheckInDate(
        formatDate(
          bookingData.checkinYear,
          bookingData.checkinMonth,
          bookingData.checkinDay
        )
      );
      setCheckOutDate(
        formatDate(
          bookingData.checkoutYear,
          bookingData.checkoutMonth,
          bookingData.checkoutDay
        )
      );
    }
  }, [bookingData]);

  useEffect(() => {
    const filtered = roomRatesData?.rates?.find(
      (item) => item.room_id === roomId
    );
    setFilteredData(filtered);
  }, [roomRatesData?.rates]);

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          if (findObject) {
            setMarkupData(findObject);
          } else {
            setMarkupData(null);
          }
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, [roomRatesData?.rates]);

  // +items.rate_per_night,
  // +bookingDiscount,
  // bookingDiscountType,
  // null,
  // null,
  // items.child_price,
  // +noOfNights,
  // +bookingData.room,
  // [],
  // rooms?.automatic_discounts

  const calculateBookingValues = (
    roomRate,
    // bookingDiscount,
    // bookingDiscountType,
    selectedBookingAutomaticDiscount,
    selectedBookingDiscount,
    agentDiscount,
    agentDiscountType,
    childPricesArray,
    noOfNights,
    noOfRooms,
    automaticDiscounts,
    commissionAmount,
    commissionType,
    extra_adult_count,
    extra_adult
  ) => {
    let childPrices = childPricesArray?.reduce((accumulator, currentPrice) => {
      const parsedPrice = parseFloat(currentPrice);
      return accumulator + (isNaN(parsedPrice) ? 0 : parsedPrice);
    }, 0);

    let newRoomRate;
    let roomRatePerNight;
    let roomRateAfterDiscount;

    roomRatePerNight = roomRate;
    newRoomRate = roomRate;
    // let extraAdultPrice = selectedMealPlan?.extra_adult_count * selectedMealPlan?.extra_adult;
    let extraAdultPrice = extra_adult_count * extra_adult;

    const calculateAutomaticDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedBookingAutomaticDiscount &&
        selectedBookingAutomaticDiscount?.length > 0 &&
        selectedBookingAutomaticDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const calculateDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedBookingDiscount &&
        selectedBookingDiscount?.length > 0 &&
        selectedBookingDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const totalBookingAutomaticDiscountAmount =
      calculateAutomaticDiscountedAmount(newRoomRate);
    const totalBookingDiscountAmount = calculateDiscountedAmount(
      Number(newRoomRate) -
        Number(
          totalBookingAutomaticDiscountAmount
            ? totalBookingAutomaticDiscountAmount
            : 0
        )
    );

    let agentDiscountAmount = 0;
    let totalDiscountAmount =
      totalBookingAutomaticDiscountAmount + totalBookingDiscountAmount;

    if (totalDiscountAmount) {
      roomRateAfterDiscount = newRoomRate - totalDiscountAmount;
    } else {
      roomRateAfterDiscount = newRoomRate;
    }

    let roomRateParsed =
      Number(roomRateAfterDiscount) * +noOfNights * +noOfRooms;
    if (isNaN(roomRateParsed)) {
      roomRateParsed = 0;
    }

    let taxSlab;

    if (roomRateAfterDiscount) {
      taxSlab = Number(roomRateAfterDiscount) > 7500 ? 18 : 12;
    } else {
      taxSlab = +roomRateAfterDiscount > 7500 ? 18 : 12;
    }

    // let subtotal =
    //   roomRateParsed - totalDiscountAmount + (+extraAdultPrice * +noOfNights) + (+childPrices * +noOfNights);
    let subtotal =
      roomRateParsed +
      +extraAdultPrice * +noOfNights +
      +childPrices * +noOfNights;

    let calculatedCommissionAmount;

    if (commissionAmount && commissionType) {
      if (commission.commissionType === "percentage") {
        calculatedCommissionAmount =
          (subtotal * commission.commissionAmount) / 100;
      } else if (commission.commissionType === "fixed") {
        calculatedCommissionAmount = commission.commissionAmount;
      }
    }
    if (calculatedCommissionAmount) {
      subtotal -= calculatedCommissionAmount;
    }

    let taxAmount = (subtotal * taxSlab) / 100;

    let grandTotal = subtotal + taxAmount;

    const grandTotalAfterAgentAdvance = grandTotal;

    // if(agentAdvanceCalculations?.pay_with_advance){
    //   grandTotal -= agentAdvanceCalculations?.advanceLimit;
    // }

    // if(agentAdvanceCalculations?.pay_with_company_credit){
    //   grandTotal -= agentAdvanceCalculations?.credit_balance;
    // }

    return {
      taxSlab,
      subtotal,
      taxAmount,
      grandTotal: Math.max(grandTotal, 0),
      discountAmt: totalDiscountAmount,
      totalChildAdultCost: childPrices * +noOfNights,
      totalAdultCost: extraAdultPrice * +noOfNights,

      childPrices,
      // bookingDiscount,
      agentDiscount,
      grandTotalAfterAgentAdvance,
      roomRate: roomRateParsed,
      automaticDiscounts,
      newRoomRate,
      extraAdultPrice,
      // extraAdultPriceWithMarkup,
      // commissionRoomRate,
      calculatedCommissionAmount,
      roomRatePerNight,
      roomRateAfterDiscount,
      // agentSavingsExtraAdult,
      // childPricesWithMarkup
    };
  };

  const fetchCommissions = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: urlencoded,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/commission/accommodation/${rooms?.hotelInfo?.id}`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        if (data?.data?.commissionType != "none") {
          setCommission(data?.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userType === "agent" && rooms) {
      fetchCommissions();
    }
  }, [userType, rooms]);

  const checkDates = (startDate, endDate) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const start = startDate.split("T")[0];
    const end = endDate.split("T")[0];
    return (
      getCurrentDateFormatted() >= start && getCurrentDateFormatted() <= end
    );
  };

  const checkBookingDates = (
    checkinBookingDate,
    checkoutBookingDate,
    discountStartDate,
    discountEndDate
  ) => {
    const checkin = checkinBookingDate?.split("T")[0];
    const checkout = checkoutBookingDate?.split("T")[0];
    const discountStart = discountStartDate?.split("T")[0];
    const discountEnd = discountEndDate?.split("T")[0];
    return checkin <= discountEnd && checkout >= discountStart;
  };

  const isPromotionApplicable = (userType, userId, promotionApplicable) => {
    if (
      Array.isArray(promotionApplicable) &&
      promotionApplicable.length === 0
    ) {
      return true;
    }

    if (promotionApplicable) {
      return promotionApplicable?.some((applicable) => {
        return (
          applicable?.applicableTo === userType &&
          applicable?.applicableIds?.includes(userId?.toString())
        );
      });
    }
  };

  const isBlackoutDate = (blackoutDates, checkDate) => {
    const normalizedCheckDate = new Date(checkDate).toLocaleDateString("en-CA");
    return blackoutDates.some((blackout) => {
      const blackoutDate = new Date(blackout.date).toISOString().split("T")[0];
      return blackoutDate === normalizedCheckDate;
    });
  };

  const isPromotionApplicableForEntity = (
    promotionEntities,
    currentEntityType,
    currentEntityId
  ) => {
    return promotionEntities.some((entity) => {
      return (
        entity.entityType === currentEntityType &&
        entity.entityIds.some(
          (id) => id.toString() === currentEntityId?.toString()
        )
      );
    });
  };

  const evaluateConditions = (conditions, validity) => {
    if (conditions.length === 0) {
      return true;
    }
    const evaluateCondition = (condition, dateToCheck) => {
      const { conditionType, conditionCondition, conditionValue } = condition;
      let startDate = checkInDate;
      let endDate = checkOutDate;
      let inputDate = new Date(dateToCheck);
      let currentDate = new Date();
      let comparisonValue;
      let valueToCompare;

      const los = calculateLOS(startDate, endDate);

      if (conditionType === "booking_date") {
        comparisonValue = moment(currentDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(currentDateSingle);
        valueToCompare = new Date(conditionValue);
      } else if (conditionType === "LOS") {
        comparisonValue = Number(los);
        valueToCompare = Number(conditionValue);
      } else {
        comparisonValue = moment(inputDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(inputDate);
        valueToCompare = new Date(conditionValue);
      }

      // console.log(comparisonValue === valueToCompare, 'llll');

      // console.log(startDate, 'startDate');
      // console.log(endDate, 'endDate');
      // console.log(inputDate, 'inputDate');
      // console.log(currentDate, 'currentDate');
      // console.log(comparisonValue, 'comparisonValue');
      // console.log(valueToCompare, 'valueToCompare');
      // console.log(los, 'los');

      switch (conditionCondition) {
        case "=":
          return comparisonValue.getTime() === valueToCompare.getTime();
        case ">":
          return comparisonValue > valueToCompare;
        case "!=":
          return comparisonValue != valueToCompare;
        case ">=":
          return comparisonValue >= valueToCompare;
        case "<":
          return comparisonValue < valueToCompare;
        case "<=":
          return comparisonValue <= valueToCompare;
        default:
          return false;
      }
    };

    if (conditions.length === 1) {
      return evaluateCondition(conditions[0], validity);
    }

    const logicalCondition = conditions[0].logicalCondition || "AND";

    let result = logicalCondition === "AND" ? true : false;

    for (const condition of conditions) {
      const conditionResult = evaluateCondition(condition, validity);

      if (logicalCondition === "OR") {
        result = result || conditionResult;
      } else {
        result = result && conditionResult;
      }
    }

    return result;
  };

  const fetchDiscountsHandler = async ({
    checkInDateFromBookingData,
    checkOutDateFromBookingData,
  }) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/promotions`,
        requestOptions
      );
      const result = await response.json();
      setPropertyDiscountArray(result?.data);

      const applicableAutomaticPromotion = result?.data
        ?.filter((item) => {
          const isAutomatic = item.promotionType === "automatic";
          const isValidDate = checkDates(item.startDate, item.endDate);
          const isBookingWithinDiscount = checkBookingDates(
            checkInDateFromBookingData,
            checkOutDateFromBookingData,
            item.startDate,
            item.endDate
          );
          const isUserEligible = isPromotionApplicable(
            userType === "customer"
              ? "customers"
              : userType === "agent"
              ? "agents"
              : "",
            userDetails?.id,
            item.promotionApplicable
          );
          const blackoutDates = item.promotionBlackOutDate || [];
          const isBlackout = isBlackoutDate(blackoutDates, checkInDate);
          const isApplicableForEntity = isPromotionApplicableForEntity(
            item.promotionEntity,
            "hotel",
            bookingData?.hotelId
          );
          const isConditionsValid = evaluateConditions(
            item.promotionConditions,
            checkInDateFromBookingData
          );

          return (
            isAutomatic &&
            isValidDate &&
            isBookingWithinDiscount &&
            isUserEligible &&
            !isBlackout &&
            isApplicableForEntity &&
            isConditionsValid
          );
        })
        ?.sort((a, b) => b.stackable - a.stackable);

      let selectedPromotions = [];
      if (applicableAutomaticPromotion.length > 0) {
        const firstPromotion = applicableAutomaticPromotion[0];
        selectedPromotions.push(firstPromotion);

        if (applicableAutomaticPromotion.length > 1) {
          const secondPromotion = applicableAutomaticPromotion[1];
          if (firstPromotion.stackable && secondPromotion.stackable) {
            selectedPromotions.push(secondPromotion);
          }
        }
      }

      // if (applicableAutomaticPromotion) {
      setSelectedAutomaticDiscount(selectedPromotions);
      // }
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
  };

  Fancybox.bind("[data-fancybox]", {
    // Fancybox options if any
  });

  const closePopup = (id) => {
    setIsPopupVisibleId(id);
  };

  const openPriceDetails = (id) => {
    setPricePopUpId(id);
  };

  const closePriceDetails = (id) => {
    setPricePopUpId(id);
  };

  const [bookingValues, setBookingValues] = useState({
    taxSlab: 0,
    subtotal: 0,
    taxAmount: 0,
    grandTotal: 0,
    discountAmt: 0,
    totalChildAdultCost: 0,
  });

  const applyDiscount = (rate, discount) => {
    let updatedRate = rate;
    let discountAmount = 0;

    if (discount) {
      if (discount.type === "percentage") {
        // Calculate discount amount for percentage
        discountAmount = (rate * parseFloat(discount.amount)) / 100;
        updatedRate = rate;
      } else if (discount.type === "fixed") {
        // Discount amount for flat discount
        discountAmount = parseFloat(discount.amount);
        updatedRate = rate;
      }

      // Ensure updated rate is not less than zero
      updatedRate = updatedRate > 0 ? updatedRate : 0;
    }

    return {
      updatedRate: updatedRate,
      discountAmount:
        bookingData?.room !== 1 ? discountAmount : discountAmount * noOfNights,
    };
  };

  const handleSelectRoomClickHandler = async (item, hotelData, room_id) => {
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      ?.map((age) => (age !== "" ? age : null))
      ?.filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      ?.map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }

    // Calculate booking values before navigating

    try {
      // calculateBookingValues(Number(8000), 20);
      await navigate(`/checkout-hotel/#booking`, {
        state: {
          item: item,
          hotelData: rooms,
          ratesData: hotelData,
          bookingData: bookingData,
          bookingValues: bookingValues,
          room_id: room_id,
          hotelPolicies: rooms.hotelInfo.hotel_policies,
        },
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const processBookingData = (
    bookingData,
    setNoOfNights,
    setCheckInDate,
    setCheckOutDate,
    fetchDiscountsHandler
  ) => {
    if (!bookingData?.checkinYear) {
      navigate("/");
      return;
    }

    const calculateNoOfNights = () => {
      const checkin = new Date(
        bookingData.checkinYear,
        bookingData.checkinMonth - 1,
        bookingData.checkinDay
      );
      const checkout = new Date(
        bookingData.checkoutYear,
        bookingData.checkoutMonth - 1,
        bookingData.checkoutDay
      );
      const diffTime = Math.abs(checkout - checkin);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    // Function to format date
    const formatDate = (year, month, day) => {
      const paddedMonth = month < 10 ? `0${month}` : month;
      const paddedDay = day < 10 ? `0${day}` : day;
      return `${year}-${paddedMonth}-${paddedDay}`;
    };

    // Set state values
    setNoOfNights(calculateNoOfNights());
    setCheckInDate(
      formatDate(
        bookingData.checkinYear,
        bookingData.checkinMonth,
        bookingData.checkinDay
      )
    );
    setCheckOutDate(
      formatDate(
        bookingData.checkoutYear,
        bookingData.checkoutMonth,
        bookingData.checkoutDay
      )
    );

    // Fetch discounts
    fetchDiscountsHandler({
      checkInDateFromBookingData: formatDate(
        bookingData.checkinYear,
        bookingData.checkinMonth,
        bookingData.checkinDay
      ),
      checkOutDateFromBookingData: formatDate(
        bookingData.checkoutYear,
        bookingData.checkoutMonth,
        bookingData.checkoutDay
      ),
    });
  };

  const handleSoldoutClickHandler = async (item, hotelData, room_id) => {
    setShowRoomGetQuotePopup(true);
    setRoomRatesData(hotelData);
    setSelectedMealPlan(item);
    setRoomId(room_id);
    processBookingData(
      bookingData,
      setNoOfNights,
      setCheckInDate,
      setCheckOutDate,
      fetchDiscountsHandler
    );
  };

  useEffect(() => {
    if (filteredData) {
      const roomRate = selectedMealPlan?.rate_per_night;
      const selectedBookingAutomaticDiscount = selectedAutomaticDiscount;
      const selectedBookingDiscount = selectedDiscount;

      // const bookingDiscount = selectedDiscount?.promotionAmount;
      // const bookingDiscountType = selectedDiscount?.promotionMode;
      const agentDiscount = userDetails?.agent_category_discount || 0;
      const agentDiscountType =
        userDetails?.agent_discount_type || "percentage";
      const commissionAmount = commission?.commissionAmount;
      const commissionType = commission?.commissionType;

      const calculatedValues = calculateBookingValues(
        +selectedMealPlan.rate_per_night,
        // +bookingDiscount,
        // bookingDiscountType,
        selectedBookingAutomaticDiscount,
        selectedBookingDiscount,
        // selectedBookingAutomaticDiscount,
        +agentDiscount,
        agentDiscountType,
        selectedMealPlan.child_price,
        +noOfNights,
        +bookingData.room,
        hotelData?.automatic_discounts,
        commissionAmount,
        commissionType,
        selectedMealPlan.extra_adult_count,
        selectedMealPlan.extra_adult
      );

      setBookingValues(calculatedValues);
    }
  }, [
    filteredData,
    userDetails?.agent_category_discount,
    // agentAdvanceCalculations?.pay_with_advance,
    // agentAdvanceCalculations?.pay_with_company_credit,
    // selectedDiscount?.promotionAmount,
    // selectedDiscount?.promotionMode,
    selectedAutomaticDiscount,
    selectedDiscount,
    commission?.commissionAmount,
    commission?.commissionType,
    markupData?.markupType,
  ]);

  useEffect(() => {
    if (bookingData) {
      processBookingData(
        bookingData,
        setNoOfNights,
        setCheckInDate,
        setCheckOutDate,
        fetchDiscountsHandler
      );
    }
  }, [bookingData, navigate]);

  const handleViewDetailsClick = (items) => {
    const calculatedValues = calculateBookingValues(
      +items?.rate_per_night,
      // +bookingDiscount,
      // bookingDiscountType,
      selectedAutomaticDiscount,
      selectedDiscount,
      // selectedBookingAutomaticDiscount,
      +agentDiscount,
      agentDiscountType,
      items?.child_price,
      +noOfNights,
      +bookingData.room,
      [],
      commission?.commissionAmount,
      commission?.commissionType,
      items?.extra_adult_count,
      items?.extra_adult
    );
    setBookingValues(calculatedValues);
  };

  // console.log(bookingValues, 'bookingValues');
  // console.log(rooms.rooms, 'rooms');
  // console.log(bookingData, 'bookingData');
  // console.log(noOfNights, 'noOfNights');

  const childAgesForPriceBreakup = bookingData?.childAge?.map((age) =>
    parseInt(age, 12)
  );
  const complimentaryChildren = childAgesForPriceBreakup?.filter(
    (age) => age < 6
  ).length;
  const extraChildrenForPricebreakup =
    bookingData?.children - complimentaryChildren;

  return (
    <>
      <div>
        {rooms &&
          rooms.rooms &&
          rooms.rooms.length > 0 &&
          rooms?.rooms?.map((cards, index) => {
            return (
              <div className={styles.NewUIRoomCard} key={index}>
                <div className={styles.room_name_occ}>
                  <h4>{cards.room_name}</h4>
                  <div className={styles.occu}>
                    Max Occ%
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                    >
                      <mask
                        id="mask0_5983_7663"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="17"
                      >
                        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5983_7663)">
                        <path
                          d="M7.66667 11.5H8.33333V7.83333H7.66667V11.5ZM8 6.88467C8.11622 6.88467 8.21367 6.84533 8.29233 6.76667C8.371 6.688 8.41033 6.59056 8.41033 6.47433C8.41033 6.35811 8.371 6.26067 8.29233 6.182C8.21367 6.10344 8.11622 6.06417 8 6.06417C7.88378 6.06417 7.78633 6.10344 7.70767 6.182C7.629 6.26067 7.58967 6.35811 7.58967 6.47433C7.58967 6.59056 7.629 6.688 7.70767 6.76667C7.78633 6.84533 7.88378 6.88467 8 6.88467ZM8.00217 14.5C7.1725 14.5 6.39244 14.3426 5.662 14.0277C4.93167 13.7128 4.29633 13.2854 3.756 12.7457C3.21567 12.2059 2.78794 11.5711 2.47283 10.8413C2.15761 10.1117 2 9.33194 2 8.50217C2 7.6725 2.15744 6.89244 2.47233 6.162C2.78722 5.43167 3.21456 4.79633 3.75433 4.256C4.29411 3.71567 4.92889 3.28794 5.65867 2.97283C6.38833 2.65761 7.16806 2.5 7.99783 2.5C8.8275 2.5 9.60756 2.65744 10.338 2.97233C11.0683 3.28722 11.7037 3.71456 12.244 4.25433C12.7843 4.79411 13.2121 5.42889 13.5272 6.15867C13.8424 6.88833 14 7.66806 14 8.49783C14 9.3275 13.8426 10.1076 13.5277 10.838C13.2128 11.5683 12.7854 12.2037 12.2457 12.744C11.7059 13.2843 11.0711 13.7121 10.3413 14.0272C9.61167 14.3424 8.83194 14.5 8.00217 14.5ZM8 13.8333C9.48889 13.8333 10.75 13.3167 11.7833 12.2833C12.8167 11.25 13.3333 9.98889 13.3333 8.5C13.3333 7.01111 12.8167 5.75 11.7833 4.71667C10.75 3.68333 9.48889 3.16667 8 3.16667C6.51111 3.16667 5.25 3.68333 4.21667 4.71667C3.18333 5.75 2.66667 7.01111 2.66667 8.5C2.66667 9.98889 3.18333 11.25 4.21667 12.2833C5.25 13.3167 6.51111 13.8333 8 13.8333Z"
                          fill="#1C1B1F"
                        />
                      </g>
                    </svg>
                  </div>
                </div>

                <div className={styles.NewUIRoomCardBottom}>
                  {/* Left Section */}
                  <div className={styles.room_details}>
                    <div className={styles.image_section}>
                      <img
                        src={cards.photos[0] ? cards.photos[0] : imgNotFound}
                        alt="hotel-img"
                      />
                      {cards?.photos?.length > 1 && (
                        <button
                          className={styles.image_overlay}
                          onClick={() => {
                            Fancybox.show(
                              cards?.photos?.map((src) => ({
                                src,
                                type: "image",
                              }))
                            );
                          }}
                        >
                          SEE ALL IMAGES
                        </button>
                      )}
                    </div>
                    <div className={styles.room_info}>
                      <p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5983_7671"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5983_7671)">
                            <path
                              d="M3.3335 16.6666V12.4999H4.16683V15.2435L7.16683 12.2435L7.75662 12.8333L4.75662 15.8333H7.50016V16.6666H3.3335ZM12.5002 16.6666V15.8333H15.2437L12.2437 12.8333L12.8335 12.2435L15.8335 15.2435V12.4999H16.6668V16.6666H12.5002ZM7.16683 7.75638L4.16683 4.75638V7.49992H3.3335V3.33325H7.50016V4.16659H4.75662L7.75662 7.16659L7.16683 7.75638ZM12.8335 7.75638L12.2437 7.16659L15.2437 4.16659H12.5002V3.33325H16.6668V7.49992H15.8335V4.75638L12.8335 7.75638ZM10.0002 11.1058C9.69614 11.1058 9.43579 10.9975 9.21912 10.781C9.00259 10.5643 8.89433 10.3039 8.89433 9.99992C8.89433 9.69589 9.00259 9.43554 9.21912 9.21888C9.43579 9.00235 9.69614 8.89408 10.0002 8.89408C10.3042 8.89408 10.5645 9.00235 10.7812 9.21888C10.9977 9.43554 11.106 9.69589 11.106 9.99992C11.106 10.3039 10.9977 10.5643 10.7812 10.781C10.5645 10.9975 10.3042 11.1058 10.0002 11.1058Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                        {cards?.additiona_details?.room_size}{" "}
                        {cards?.additiona_details?.room_area_unit}{" "}
                      </p>
                      <p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5983_7676"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5983_7676)">
                            <path
                              d="M5.51292 13.6538H6.25V12.4038H13.75V13.6538H14.4871V10.6762C14.4871 10.3024 14.3699 9.98694 14.1354 9.73C13.901 9.47306 13.6015 9.32694 13.2371 9.29167V8.20521C13.2371 7.8216 13.1086 7.50132 12.8517 7.24437C12.5947 6.98743 12.2745 6.85896 11.891 6.85896H8.10896C7.72549 6.85896 7.40528 6.98743 7.14833 7.24437C6.89139 7.50132 6.76292 7.8216 6.76292 8.20521V9.29167C6.39847 9.32694 6.09903 9.47306 5.86458 9.73C5.63014 9.98694 5.51292 10.3024 5.51292 10.6762V13.6538ZM6.25 11.6667V10.6762C6.25 10.4818 6.3141 10.3205 6.44229 10.1923C6.57049 10.0641 6.73181 10 6.92625 10H13.0737C13.2682 10 13.4295 10.0641 13.5577 10.1923C13.6859 10.3205 13.75 10.4818 13.75 10.6762V11.6667H6.25ZM7.5 9.26292V8.10896C7.5 7.95937 7.54806 7.83653 7.64417 7.74042C7.74042 7.6443 7.86333 7.59625 8.01292 7.59625H11.9871C12.1367 7.59625 12.2596 7.6443 12.3558 7.74042C12.4519 7.83653 12.5 7.95937 12.5 8.10896V9.26292H7.5ZM3.84625 17.5C3.46264 17.5 3.14236 17.3715 2.88542 17.1146C2.62847 16.8576 2.5 16.5374 2.5 16.1538V3.84625C2.5 3.46264 2.62847 3.14236 2.88542 2.88542C3.14236 2.62847 3.46264 2.5 3.84625 2.5H16.1538C16.5374 2.5 16.8576 2.62847 17.1146 2.88542C17.3715 3.14236 17.5 3.46264 17.5 3.84625V16.1538C17.5 16.5374 17.3715 16.8576 17.1146 17.1146C16.8576 17.3715 16.5374 17.5 16.1538 17.5H3.84625ZM3.84625 16.6667H16.1538C16.2821 16.6667 16.3997 16.6133 16.5065 16.5065C16.6133 16.3997 16.6667 16.2821 16.6667 16.1538V3.84625C16.6667 3.71792 16.6133 3.60035 16.5065 3.49354C16.3997 3.38674 16.2821 3.33333 16.1538 3.33333H3.84625C3.71792 3.33333 3.60035 3.38674 3.49354 3.49354C3.38674 3.60035 3.33333 3.71792 3.33333 3.84625V16.1538C3.33333 16.2821 3.38674 16.3997 3.49354 16.5065C3.60035 16.6133 3.71792 16.6667 3.84625 16.6667Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                        <span style={{ textTransform: "capitalize" }}>
                          {cards?.additiona_details?.bed_type?.replace(
                            "-",
                            " "
                          )}{" "}
                        </span>
                      </p>
                      <p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <mask
                            id="mask0_5983_7676"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                          >
                            <rect width="20" height="20" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_5983_7676)">
                            <path
                              d="M5.51292 13.6538H6.25V12.4038H13.75V13.6538H14.4871V10.6762C14.4871 10.3024 14.3699 9.98694 14.1354 9.73C13.901 9.47306 13.6015 9.32694 13.2371 9.29167V8.20521C13.2371 7.8216 13.1086 7.50132 12.8517 7.24437C12.5947 6.98743 12.2745 6.85896 11.891 6.85896H8.10896C7.72549 6.85896 7.40528 6.98743 7.14833 7.24437C6.89139 7.50132 6.76292 7.8216 6.76292 8.20521V9.29167C6.39847 9.32694 6.09903 9.47306 5.86458 9.73C5.63014 9.98694 5.51292 10.3024 5.51292 10.6762V13.6538ZM6.25 11.6667V10.6762C6.25 10.4818 6.3141 10.3205 6.44229 10.1923C6.57049 10.0641 6.73181 10 6.92625 10H13.0737C13.2682 10 13.4295 10.0641 13.5577 10.1923C13.6859 10.3205 13.75 10.4818 13.75 10.6762V11.6667H6.25ZM7.5 9.26292V8.10896C7.5 7.95937 7.54806 7.83653 7.64417 7.74042C7.74042 7.6443 7.86333 7.59625 8.01292 7.59625H11.9871C12.1367 7.59625 12.2596 7.6443 12.3558 7.74042C12.4519 7.83653 12.5 7.95937 12.5 8.10896V9.26292H7.5ZM3.84625 17.5C3.46264 17.5 3.14236 17.3715 2.88542 17.1146C2.62847 16.8576 2.5 16.5374 2.5 16.1538V3.84625C2.5 3.46264 2.62847 3.14236 2.88542 2.88542C3.14236 2.62847 3.46264 2.5 3.84625 2.5H16.1538C16.5374 2.5 16.8576 2.62847 17.1146 2.88542C17.3715 3.14236 17.5 3.46264 17.5 3.84625V16.1538C17.5 16.5374 17.3715 16.8576 17.1146 17.1146C16.8576 17.3715 16.5374 17.5 16.1538 17.5H3.84625ZM3.84625 16.6667H16.1538C16.2821 16.6667 16.3997 16.6133 16.5065 16.5065C16.6133 16.3997 16.6667 16.2821 16.6667 16.1538V3.84625C16.6667 3.71792 16.6133 3.60035 16.5065 3.49354C16.3997 3.38674 16.2821 3.33333 16.1538 3.33333H3.84625C3.71792 3.33333 3.60035 3.38674 3.49354 3.49354C3.38674 3.60035 3.33333 3.71792 3.33333 3.84625V16.1538C3.33333 16.2821 3.38674 16.3997 3.49354 16.5065C3.60035 16.6133 3.71792 16.6667 3.84625 16.6667Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                        <span style={{ textTransform: "capitalize" }}>
                          {cards?.additiona_details?.room_view?.replace(
                            "-",
                            " "
                          )}
                        </span>
                      </p>

                      {cards?.additiona_details && (
                        <button
                          onClick={() => openPopup(cards?.room_id)}
                          className={styles.more_details}
                        >
                          More Details
                        </button>
                      )}
                      {isPopupVisibleId === cards?.room_id && (
                        <div className="popup_backdrop">
                          <div className="popup_section">
                            <div className="agent">
                              <div className="popup_section_heading">
                                <h6>{cards?.room_name}</h6>
                              </div>
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                onClick={closePopup}
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 13L13 1"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                                <path
                                  d="M13 13L0.999999 1"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                              </svg>
                            </div>
                            <hr />
                            <div>
                              <h6 className="mt-10">Highlights</h6>
                              <div className="flex flex_direction_col justify_content_between flex_wrap popup_section_ul">
                                <ul className="flex flex_wrap popup_section_ul">
                                  {Object.entries(
                                    cards?.additiona_details || {}
                                  ).length > 0 ? (
                                    Object.entries(cards.additiona_details)
                                      .filter(([key, value]) => value)
                                      .map(([key, value], index) => (
                                        <li
                                          style={{
                                            width: "100%",
                                            fontSize: "12px",
                                            color: "rgb(85, 85, 85)",
                                          }}
                                          key={index}
                                        >
                                          <strong className="text-capitalize">
                                            {key.replace(/_/g, " ")}:
                                          </strong>
                                          {"  "}
                                          {value}
                                        </li>
                                      ))
                                  ) : (
                                    <p>No additional details available.</p>
                                  )}
                                </ul>
                              </div>

                              {cards?.amenities &&
                                cards?.amenities.length > 0 && (
                                  <>
                                    <h6 className="mt-10">
                                      <b>Room Amenities</b>
                                    </h6>
                                    <div className="flex flex_direction_col justify_content_between flex_wrap">
                                      <ul
                                        className="flex flex_wrap"
                                        style={{ paddingLeft: "22px" }}
                                      >
                                        {Object.entries(cards?.amenities || {})
                                          .length > 0 &&
                                          Object.entries(
                                            cards.additiona_details
                                          )
                                            .filter(([key, value]) => value)
                                            .map(([key, value], index) => (
                                              <li
                                                style={{
                                                  width: "100%",
                                                  fontSize: "12px",
                                                  color: "rgb(85, 85, 85)",
                                                }}
                                                key={index}
                                              >
                                                <strong className="text-capitalize">
                                                  {key.replace(/_/g, " ")}:
                                                </strong>
                                                {"  "}
                                                {value}
                                              </li>
                                            ))}
                                      </ul>
                                    </div>
                                  </>
                                )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Right Section */}
                  <div className={styles.room_options}>
                    {cards?.rates && cards?.rates.length > 0 ? (
                      <>
                        {cards?.rates?.map((items, index) => {
                          return (
                            <div
                              className={styles.room_options_meal_plans}
                              key={items.id || index}
                            >
                              <div className={styles.room_type} key={index}>
                                <h4>
                                  {items.meal_plan_name} ({items.meal_plan})
                                  {/* <span className={styles.discount}>20% OFF</span> */}
                                </h4>
                                <ul>
                                  <li>Welcome Drinks on Arrivals</li>
                                  <li>
                                    Early Check-In, Check Out (subject to
                                    availability)
                                  </li>
                                  <li>
                                    Free Cancellation before 7 Days
                                    {/* <a href="#">Know More</a> */}
                                  </li>
                                </ul>
                              </div>
                              <div className={styles.price_section}>
                                <div className={styles.price}>
                                  <strong>
                                    {formatIndianCurrency(items.rate_per_night)}
                                  </strong>
                                  <span>+Tax</span>
                                  <button
                                    className={styles.price_details_btn}
                                    type="button"
                                    onClick={() => {
                                      setSelectedMealPlan(items);
                                      handleViewDetailsClick(items);
                                      openPriceDetails(items.rate_plan_id);
                                    }}
                                  >
                                    Price Details
                                  </button>
                                </div>

                                {/* <button className={styles.select_room}>SELECT ROOM</button> */}

                                {items.status === "AVAILABLE" ? (
                                  <>
                                    {items.add_rooms &&
                                    Number(items.required_rooms) >=
                                      Number(bookingData.room) ? (
                                      <button
                                        className={styles.select_room}
                                        style={{
                                          cursor: "not-allowed",
                                          background: "grey",
                                          width: "120px",
                                        }}
                                        disabled
                                      >
                                        PLEASE ADD ROOM
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() =>
                                          handleSelectRoomClickHandler(
                                            items,
                                            cards,
                                            items.room_id
                                          )
                                        }
                                        className={styles.select_room}
                                      >
                                        Select Rooms
                                      </button>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {items.add_rooms &&
                                    Number(items.required_rooms) <=
                                      Number(rooms) ? (
                                      <button
                                        className="primary_btn"
                                        style={{
                                          cursor: "not-allowed",
                                          background: "grey",
                                          width: "120px",
                                        }}
                                        disabled
                                      >
                                        PLEASE ADD ROOM
                                      </button>
                                    ) : (
                                      // </CustomTooltip>
                                      <button
                                        className={styles.select_room}
                                        onClick={() =>
                                          handleSoldoutClickHandler(
                                            items,
                                            cards,
                                            items.room_id
                                          )
                                        }
                                      >
                                        Get Quote
                                      </button>
                                    )}
                                  </>
                                )}

                                {/* <p className={styles.login_savings}>Login Now & Save Extra</p> */}
                              </div>

                              {pricePopUpId === items.rate_plan_id && (
                                <div className="popup_backdrop">
                                  <div className="popup_section">
                                    <div className="agent">
                                      <div>
                                        <h6 style={{ fontSize: "16px" }}>
                                          {cards.room_name}
                                        </h6>
                                        <p style={{ textAlign: "left" }}>
                                          {items.meal_plan_name || "N/A"}
                                        </p>
                                      </div>
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        onClick={closePriceDetails}
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M1 13L13 1"
                                          stroke="#AAAAAA"
                                          strokeWidth="1.2"
                                        />
                                        <path
                                          d="M13 13L1 1"
                                          stroke="#AAAAAA"
                                          strokeWidth="1.2"
                                        />
                                      </svg>
                                    </div>
                                    <hr />
                                    <div>
                                      {(selectedAutomaticDiscount.length > 0 ||
                                        selectedDiscount.length > 0) && (
                                        <div className="mt-10">
                                          <p style={{ textAlign: "left" }}>
                                            Property Discount
                                            {selectedAutomaticDiscount?.length >
                                            1
                                              ? "s"
                                              : ""}
                                          </p>
                                          {selectedAutomaticDiscount?.map(
                                            (discount, index) => (
                                              <div
                                                className="flex justify_content_between mt-2"
                                                key={index}
                                              >
                                                <span
                                                  className="discount-name"
                                                  style={{ color: "green" }}
                                                >
                                                  {discount.promotionName}
                                                </span>
                                                <span
                                                  className="room_text-right green"
                                                  style={{ color: "green" }}
                                                >
                                                  {discount.promotionMode ===
                                                  "percentage"
                                                    ? `${+discount.promotionAmount}%`
                                                    : `${formatIndianCurrency(
                                                        discount.promotionAmount
                                                      )}`}
                                                </span>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}

                                      <div className="agent">
                                        <p>
                                          Room Rate <small>(Per Night)</small>
                                        </p>
                                        <span
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "end",
                                          }}
                                        >
                                          {(selectedAutomaticDiscount.length >
                                            0 ||
                                            selectedDiscount.length > 0) &&
                                            bookingValues.newRoomRate &&
                                            bookingValues.roomRateAfterDiscount && (
                                              <small
                                                style={{
                                                  color: "red",
                                                  textDecoration:
                                                    "line-through",
                                                }}
                                              >
                                                {formatIndianCurrency(
                                                  bookingValues?.roomRatePerNight
                                                )}
                                              </small>
                                            )}

                                          {formatIndianCurrency(
                                            bookingValues.roomRateAfterDiscount
                                              ? bookingValues.roomRateAfterDiscount
                                              : bookingValues.newRoomRate
                                          )}
                                        </span>
                                      </div>

                                      {(bookingData?.room > 1 ||
                                        noOfNights > 1) && (
                                        <div className="flex justify_content_between mt-10">
                                          <p>
                                            {noOfNights} Night *{" "}
                                            {bookingData?.room} Rooms
                                          </p>
                                          <span className="room_text-right">
                                            {/* {formatIndianCurrency(
                                                                                                    selectedPlan?.rate_per_night *
                                                                                                    bookingData?.room *
                                                                                                    noOfNights
                                                                                                  )} */}
                                            {formatIndianCurrency(
                                              bookingValues?.roomRate
                                            )}
                                          </span>
                                        </div>
                                      )}

                                      {selectedMealPlan?.extra_adult_count >
                                        0 && (
                                        <div className="flex justify_content_between mt-10">
                                          <p>
                                            {
                                              selectedMealPlan?.extra_adult_count
                                            }{" "}
                                            Extra Adult{" "}
                                            <small>
                                              (
                                              {formatIndianCurrency(
                                                bookingValues?.extraAdultPrice
                                              )}{" "}
                                              * {noOfNights} Night){" "}
                                            </small>{" "}
                                          </p>
                                          <span className="room_text-right">
                                            {formatIndianCurrency(
                                              bookingValues?.totalAdultCost
                                            )}
                                          </span>
                                        </div>
                                      )}

                                      {bookingValues?.childPrices > 0 && (
                                        <div className="flex justify_content_between mt-10">
                                          <p>
                                            {extraChildrenForPricebreakup} Extra
                                            Child{" "}
                                            <small>
                                              {" "}
                                              (
                                              {formatIndianCurrency(
                                                bookingValues?.childPrices
                                              )}{" "}
                                              * {noOfNights} Night){" "}
                                            </small>{" "}
                                          </p>
                                          <span className="room_text-right">
                                            {formatIndianCurrency(
                                              bookingValues?.totalChildAdultCost
                                            )}
                                          </span>
                                        </div>
                                      )}

                                      {complimentaryChildren > 0 && (
                                        <div className="flex justify_content_between mt-10">
                                          <p>
                                            {complimentaryChildren}{" "}
                                            Complimentary Child
                                          </p>
                                          <span className="room_text-right">
                                            Free
                                          </span>
                                        </div>
                                      )}

                                      <div className="flex justify_content_between mt-10">
                                        <p>Subtotal</p>
                                        <span className="room_text-right">
                                          {formatIndianCurrency(
                                            bookingValues.subtotal
                                          )}
                                        </span>
                                      </div>

                                      <div className="flex justify_content_between mt-10">
                                        <p>
                                          Tax Amount ({bookingValues?.taxSlab}%)
                                        </p>
                                        <span className="room_text-right">
                                          {formatIndianCurrency(
                                            bookingValues.taxAmount
                                          )}
                                        </span>
                                      </div>

                                      <div className="flex justify_content_between mt-10">
                                        <h6>Grand Total</h6>
                                        <h6>
                                          {formatIndianCurrency(
                                            bookingValues?.grandTotal
                                          )}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className={styles.noRatesGetSection}>
                        <div className={styles.no_rates_added_text_hotel}>
                          <p>
                            Looking for hotel rates in the distant future? Our
                            current booking system focuses on nearer dates, but
                            our Sales Team specializes in long-term planning!
                            Contact us today to discuss customized rates, group
                            bookings, or special events.{" "}
                          </p>

                          <Link to={"/contact-us"}>Inquire Now</Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      {showRoomGetQuotePopup && (
        <NewSingleQueryPopup
          setshowRatePopup={setShowRoomGetQuotePopup}
          bookingData={bookingData}
          noOfNights={noOfNights}
          hotelData={rooms}
          ratesData={roomRatesData}
          bookingValues={bookingValues}
          selectedAutomaticDiscount={selectedAutomaticDiscount}
          selectedDiscount={selectedDiscount}
          selectedMealPlan={selectedMealPlan}
          commission={commission}
          typeDetail="hotel"
        />
      )}
    </>
  );
}

export default NewUISingleHotelRoomCard;

// <section className="SingleRoomCard-Main">
// {rooms &&
//     rooms.rooms &&
//     rooms.rooms.length > 0 &&
//     rooms?.rooms?.map((cards, index) => {
//         return (
//             <div className="single-room-card" key={index}>
//                 <div className="card_head p_0">
//                     <div className="flex justify_content_between flex_wrap p_10">
//                         <h4>
//                             {cards.room_name} {"  "}
//                             <small style={{ textTransform: "capitalize" }}>
//                                 {" "}
//                                 ({cards?.additiona_details?.room_view?.replace("-", " ")})
//                             </small>
//                         </h4>
//                         <div className="flex flex_gap_10 font_12">
//                             <span className="room_plan">
//                                 <svg
//                                     width="18"
//                                     height="12"
//                                     viewBox="0 0 18 12"
//                                     fill="none"
//                                     xmlns="http://www.w3.org/2000/svg"
//                                 >
//                                     <path
//                                         d="M0.666992 11.8333V6.83329C0.666992 6.45829 0.743381 6.11802 0.896159 5.81246C1.04894 5.5069 1.25033 5.23607 1.50033 4.99996V2.66663C1.50033 1.97218 1.74338 1.3819 2.22949 0.895793C2.7156 0.409682 3.30588 0.166626 4.00033 0.166626H7.33366C7.6531 0.166626 7.95171 0.225654 8.22949 0.343709C8.50727 0.461765 8.76421 0.624959 9.00033 0.833293C9.23644 0.624959 9.49338 0.461765 9.77116 0.343709C10.0489 0.225654 10.3475 0.166626 10.667 0.166626H14.0003C14.6948 0.166626 15.285 0.409682 15.7712 0.895793C16.2573 1.3819 16.5003 1.97218 16.5003 2.66663V4.99996C16.7503 5.23607 16.9517 5.5069 17.1045 5.81246C17.2573 6.11802 17.3337 6.45829 17.3337 6.83329V11.8333H15.667V10.1666H2.33366V11.8333H0.666992ZM9.83366 4.33329H14.8337V2.66663C14.8337 2.43052 14.7538 2.2326 14.5941 2.07288C14.4344 1.91315 14.2364 1.83329 14.0003 1.83329H10.667C10.4309 1.83329 10.233 1.91315 10.0732 2.07288C9.91352 2.2326 9.83366 2.43052 9.83366 2.66663V4.33329ZM3.16699 4.33329H8.16699V2.66663C8.16699 2.43052 8.08713 2.2326 7.92741 2.07288C7.76769 1.91315 7.56977 1.83329 7.33366 1.83329H4.00033C3.76421 1.83329 3.5663 1.91315 3.40658 2.07288C3.24685 2.2326 3.16699 2.43052 3.16699 2.66663V4.33329ZM2.33366 8.49996H15.667V6.83329C15.667 6.59718 15.5871 6.39927 15.4274 6.23954C15.2677 6.07982 15.0698 5.99996 14.8337 5.99996H3.16699C2.93088 5.99996 2.73296 6.07982 2.57324 6.23954C2.41352 6.39927 2.33366 6.59718 2.33366 6.83329V8.49996Z"
//                                         fill="#333333"
//                                     />
//                                 </svg>
//                                 <span style={{ textTransform: "capitalize" }}>
//                                     {cards?.additiona_details?.bed_type?.replace("-", " ")}{" "}
//                                 </span>
//                             </span>
//                             <span className="room_plan">
//                                 <svg
//                                     width="18"
//                                     height="14"
//                                     viewBox="0 0 18 14"
//                                     fill="none"
//                                     xmlns="http://www.w3.org/2000/svg"
//                                 >
//                                     <path
//                                         d="M10.667 11.1667H14.8337V7.00004H13.167V9.50004H10.667V11.1667ZM3.16699 7.00004H4.83366V4.50004H7.33366V2.83337H3.16699V7.00004ZM2.33366 13.6667C1.87533 13.6667 1.48296 13.5035 1.15658 13.1771C0.830187 12.8507 0.666992 12.4584 0.666992 12V2.00004C0.666992 1.54171 0.830187 1.14935 1.15658 0.822957C1.48296 0.496568 1.87533 0.333374 2.33366 0.333374H15.667C16.1253 0.333374 16.5177 0.496568 16.8441 0.822957C17.1705 1.14935 17.3337 1.54171 17.3337 2.00004V12C17.3337 12.4584 17.1705 12.8507 16.8441 13.1771C16.5177 13.5035 16.1253 13.6667 15.667 13.6667H2.33366ZM2.33366 12H15.667V2.00004H2.33366V12Z"
//                                         fill="#333333"
//                                     />
//                                 </svg>{" "}
//                                 {cards?.additiona_details?.room_size} {cards?.additiona_details?.room_area_unit}{" "}
//                             </span>
//                             <span className="room_plan">
//                                 <svg
//                                     width="20"
//                                     height="20"
//                                     viewBox="0 0 20 20"
//                                     fill="none"
//                                     xmlns="http://www.w3.org/2000/svg"
//                                 >
//                                     <mask
//                                         id="mask0_3149_3904"
//                                         maskUnits="userSpaceOnUse"
//                                         x="0"
//                                         y="0"
//                                         width="20"
//                                         height="20"
//                                     >
//                                         <rect width="20" height="20" fill="#D9D9D9" />
//                                     </mask>
//                                     <g mask="url(#mask0_3149_3904)">
//                                         <path
//                                             d="M0.958984 16.6667L3.83398 10.9167C3.97287 10.6389 4.17079 10.4167 4.42773 10.25C4.68468 10.0834 4.97287 10 5.29232 10C5.62565 10 5.93121 10.0868 6.20898 10.2605C6.48676 10.4341 6.68815 10.6806 6.81315 11L7.37565 12.375C7.40343 12.4584 7.46593 12.4966 7.56315 12.4896C7.66037 12.4827 7.72287 12.4375 7.75065 12.3542L9.54232 6.37504C9.73676 5.70837 10.1083 5.17365 10.6569 4.77087C11.2055 4.3681 11.827 4.16671 12.5215 4.16671C13.202 4.16671 13.8097 4.36462 14.3444 4.76046C14.8791 5.15629 15.2507 5.67365 15.459 6.31254L19.0632 16.6667H17.2923L13.8757 6.83337C13.7645 6.51393 13.5909 6.2674 13.3548 6.09379C13.1187 5.92018 12.8409 5.83337 12.5215 5.83337C12.202 5.83337 11.9208 5.92365 11.6777 6.10421C11.4347 6.28476 11.2576 6.53476 11.1465 6.85421L9.35482 12.8334C9.22982 13.2223 9.00412 13.5417 8.67773 13.7917C8.35135 14.0417 7.97982 14.1667 7.56315 14.1667C7.18815 14.1667 6.84093 14.066 6.52148 13.8646C6.20204 13.6632 5.97287 13.382 5.83398 13.0209L5.27148 11.6459L2.81315 16.6667H0.958984ZM5.00065 8.33337C4.30621 8.33337 3.71593 8.08685 3.22982 7.59379C2.74371 7.10074 2.50065 6.51393 2.50065 5.83337C2.50065 5.13893 2.74371 4.54865 3.22982 4.06254C3.71593 3.57643 4.30621 3.33337 5.00065 3.33337C5.6951 3.33337 6.28537 3.57643 6.77148 4.06254C7.2576 4.54865 7.50065 5.13893 7.50065 5.83337C7.50065 6.51393 7.2576 7.10074 6.77148 7.59379C6.28537 8.08685 5.6951 8.33337 5.00065 8.33337ZM5.00065 6.66671C5.23676 6.66671 5.43468 6.58685 5.5944 6.42712C5.75412 6.2674 5.83398 6.06948 5.83398 5.83337C5.83398 5.59726 5.75412 5.39935 5.5944 5.23962C5.43468 5.0799 5.23676 5.00004 5.00065 5.00004C4.76454 5.00004 4.56662 5.0799 4.4069 5.23962C4.24718 5.39935 4.16732 5.59726 4.16732 5.83337C4.16732 6.06948 4.24718 6.2674 4.4069 6.42712C4.56662 6.58685 4.76454 6.66671 5.00065 6.66671Z"
//                                             fill="#333333"
//                                         />
//                                     </g>
//                                 </svg>
//                                 <span style={{ textTransform: "capitalize" }}>
//                                     {cards?.additiona_details?.room_view?.replace("-", " ")}
//                                 </span>
//                             </span>
//                             {cards?.additiona_details ? (
//                                 <button
//                                     onClick={() => openPopup(cards?.room_id)}
//                                     className="details_btn"
//                                 >
//                                     <svg
//                                         width="14"
//                                         height="14"
//                                         viewBox="0 0 14 14"
//                                         fill="none"
//                                         xmlns="http://www.w3.org/2000/svg"
//                                     >
//                                         <path
//                                             d="M6.33301 10.3334H7.66634V6.33337H6.33301V10.3334ZM6.99967 5.00004C7.18856 5.00004 7.34701 4.93604 7.47501 4.80804C7.60301 4.68004 7.66679 4.52182 7.66634 4.33337C7.66634 4.14448 7.60234 3.98604 7.47434 3.85804C7.34634 3.73004 7.18812 3.66626 6.99967 3.66671C6.81079 3.66671 6.65234 3.73071 6.52434 3.85871C6.39634 3.98671 6.33256 4.14493 6.33301 4.33337C6.33301 4.52226 6.39701 4.68071 6.52501 4.80871C6.65301 4.93671 6.81123 5.00048 6.99967 5.00004ZM6.99967 13.6667C6.07745 13.6667 5.21079 13.4916 4.39967 13.1414C3.58856 12.7912 2.88301 12.3163 2.28301 11.7167C1.68301 11.1167 1.20812 10.4112 0.858341 9.60004C0.508563 8.78893 0.333452 7.92226 0.333008 7.00004C0.333008 6.07782 0.508119 5.21115 0.858341 4.40004C1.20856 3.58893 1.68345 2.88337 2.28301 2.28337C2.88301 1.68337 3.58856 1.20849 4.39967 0.858707C5.21079 0.50893 6.07745 0.333818 6.99967 0.333374C7.9219 0.333374 8.78856 0.508485 9.59967 0.858707C10.4108 1.20893 11.1163 1.68382 11.7163 2.28337C12.3163 2.88337 12.7915 3.58893 13.1417 4.40004C13.4919 5.21115 13.6668 6.07782 13.6663 7.00004C13.6663 7.92226 13.4912 8.78893 13.141 9.60004C12.7908 10.4112 12.3159 11.1167 11.7163 11.7167C11.1163 12.3167 10.4108 12.7918 9.59967 13.142C8.78856 13.4923 7.9219 13.6672 6.99967 13.6667ZM6.99967 12.3334C8.48856 12.3334 9.74967 11.8167 10.783 10.7834C11.8163 9.75004 12.333 8.48893 12.333 7.00004C12.333 5.51115 11.8163 4.25004 10.783 3.21671C9.74967 2.18337 8.48856 1.66671 6.99967 1.66671C5.51079 1.66671 4.24967 2.18337 3.21634 3.21671C2.18301 4.25004 1.66634 5.51115 1.66634 7.00004C1.66634 8.48893 2.18301 9.75004 3.21634 10.7834C4.24967 11.8167 5.51079 12.3334 6.99967 12.3334Z"
//                                             fill="#016937"
//                                             onClick={() => closePopup(null)}
//                                         />
//                                     </svg>
//                                     More Details
//                                 </button>
//                             ) : (
//                                 ""
//                             )}
//                             {isPopupVisibleId === cards?.room_id && (
//                                 <div className="popup_backdrop">
//                                     <div className="popup_section">
//                                         <div className="agent">
//                                             <div>
//                                                 <h6>
//                                                     <b>{cards?.room_name}</b>
//                                                 </h6>
//                                             </div>
//                                             <svg
//                                                 width="14"
//                                                 height="14"
//                                                 viewBox="0 0 14 14"
//                                                 fill="none"
//                                                 onClick={closePopup}
//                                                 xmlns="http://www.w3.org/2000/svg"
//                                             >
//                                                 <path
//                                                     d="M1 13L13 1"
//                                                     stroke="#AAAAAA"
//                                                     strokeWidth="1.2"
//                                                 />
//                                                 <path
//                                                     d="M13 13L0.999999 1"
//                                                     stroke="#AAAAAA"
//                                                     strokeWidth="1.2"
//                                                 />
//                                             </svg>
//                                         </div>
//                                         <hr />
//                                         <div>
//                                             <h6 className="mt-10">
//                                                 <b>Highlights</b>
//                                             </h6>
//                                             <div className="flex flex_direction_col justify_content_between flex_wrap">
//                                                 <ul class="flex flex_wrap" style={{ paddingLeft: '22px' }}>
//                                                     {Object.entries(cards?.additiona_details || {}).length > 0 ? (
//                                                         Object.entries(cards.additiona_details)
//                                                             .filter(([key, value]) => value)
//                                                             .map(([key, value], index) => (
//                                                                 <li style={{ width: '100%', fontSize: '12px', color: 'rgb(85, 85, 85)' }}>
//                                                                     <strong className="text-capitalize">{key
//                                                                         .replace(/_/g, ' ')}:
//                                                                     </strong>{'  '}{value}
//                                                                 </li>
//                                                             ))
//                                                     ) : (
//                                                         <p>No additional details available.</p>
//                                                     )}
//                                                 </ul>
//                                             </div>

//                                             {cards?.amenities && cards?.amenities.length > 0 && (
//                                                 <>
//                                                     <h6 className="mt-10">
//                                                         <b>Room Amenities</b>
//                                                     </h6>
//                                                     <div className="flex flex_direction_col justify_content_between flex_wrap">
//                                                         <ul class="flex flex_wrap" style={{ paddingLeft: '22px' }}>
//                                                             {Object.entries(cards?.amenities || {}).length > 0 && (
//                                                                 Object.entries(cards.additiona_details)
//                                                                     .filter(([key, value]) => value)
//                                                                     .map(([key, value], index) => (
//                                                                         <li style={{ width: '100%', fontSize: '12px', color: 'rgb(85, 85, 85)' }}>
//                                                                             <strong className="text-capitalize">{key
//                                                                                 .replace(/_/g, ' ')}:
//                                                                             </strong>{'  '}{value}
//                                                                         </li>
//                                                                     ))
//                                                             )}
//                                                         </ul>
//                                                     </div>
//                                                 </>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//                 <div className="SingleHotel-Details single_room_data_">
//                     <div className="hotel_view_img">
//                         {rooms?.automatic_discounts?.amount ? (
//                             <div
//                                 style={{
//                                     position: "absolute",
//                                     top: "10px",
//                                     left: "10px",
//                                     background: "#016937",
//                                     color: "#fff",
//                                     padding: "2px 5px",
//                                     borderRadius: "5px",
//                                 }}
//                             >
//                                 {rooms?.automatic_discounts?.type === "percentage"
//                                     ? `${+rooms?.automatic_discounts?.amount}% OFF`
//                                     : `${formatIndianCurrency(
//                                         rooms?.automatic_discounts?.amount
//                                     )} OFF`}
//                             </div>
//                         ) : null}
//                         <img
//                             src={cards.photos[0] ? cards.photos[0] : imgNotFound}
//                             alt="hotel-img"
//                         />
//                         {cards?.photos?.length > 1 && (
//                             <div>
//                                 <button
//                                     className="view_images_btn"
//                                     onClick={() => {
//                                         Fancybox.show(
//                                             cards?.photos?.map((src) => ({
//                                                 src,
//                                                 type: "image",
//                                             }))
//                                         );
//                                     }}
//                                 >
//                                     <svg
//                                         width="10"
//                                         height="10"
//                                         viewBox="0 0 16 15"
//                                         xmlns="http://www.w3.org/2000/svg"
//                                     >
//                                         <path
//                                             d="M8 11.625C8.9375 11.625 9.73438 11.2969 10.3906 10.6406C11.0469 9.98438 11.375 9.1875 11.375 8.25C11.375 7.3125 11.0469 6.51562 10.3906 5.85938C9.73438 5.20312 8.9375 4.875 8 4.875C7.0625 4.875 6.26562 5.20312 5.60938 5.85938C4.95312 6.51562 4.625 7.3125 4.625 8.25C4.625 9.1875 4.95312 9.98438 5.60938 10.6406C6.26562 11.2969 7.0625 11.625 8 11.625ZM8 10.125C7.475 10.125 7.03125 9.94375 6.66875 9.58125C6.30625 9.21875 6.125 8.775 6.125 8.25C6.125 7.725 6.30625 7.28125 6.66875 6.91875C7.03125 6.55625 7.475 6.375 8 6.375C8.525 6.375 8.96875 6.55625 9.33125 6.91875C9.69375 7.28125 9.875 7.725 9.875 8.25C9.875 8.775 9.69375 9.21875 9.33125 9.58125C8.96875 9.94375 8.525 10.125 8 10.125ZM2 14.25C1.5875 14.25 1.23438 14.1031 0.940625 13.8094C0.646875 13.5156 0.5 13.1625 0.5 12.75V3.75C0.5 3.3375 0.646875 2.98438 0.940625 2.69063C1.23438 2.39688 1.5875 2.25 2 2.25H4.3625L5.75 0.75H10.25L11.6375 2.25H14C14.4125 2.25 14.7656 2.39688 15.0594 2.69063C15.3531 2.98438 15.5 3.3375 15.5 3.75V12.75C15.5 13.1625 15.3531 13.5156 15.0594 13.8094C14.7656 14.1031 14.4125 14.25 14 14.25H2ZM2 12.75H14V3.75H10.9625L9.59375 2.25H6.40625L5.0375 3.75H2V12.75Z"
//                                             fill="white"
//                                         />
//                                     </svg>
//                                     view all images
//                                 </button>
//                             </div>
//                         )}
//                     </div>

//                     <div className="rooms_content">
//                         {cards?.rates?.map((items, index) => {
//                             return (
//                                 <div className="single_room_details" key={index}>
//                                     <div>
//                                         <p>
//                                             {items.meal_plan_name}{" "}
//                                             <small>({items.meal_plan})</small>
//                                         </p>
//                                         <button
//                                             type="button"
//                                             onClick={() => {
//                                                 setSelectedMealPlan(items)
//                                                 handleViewDetailsClick(items);
//                                                 openPriceDetails(items.rate_plan_id);
//                                             }}
//                                             className="view_btn"
//                                         >
//                                             View Price Details
//                                         </button>

//                                         {pricePopUpId === items.rate_plan_id && (
//                                             <div className="popup_backdrop">
//                                                 <div className="popup_section">
//                                                     <div className="agent">
//                                                         <div>
//                                                             <h6>
//                                                                 <b>{cards.room_name}</b>
//                                                             </h6>
//                                                             <p style={{ textAlign: "left" }}>
//                                                                 {items.meal_plan_name || "N/A"}
//                                                             </p>
//                                                         </div>
//                                                         <svg
//                                                             width="14"
//                                                             height="14"
//                                                             viewBox="0 0 14 14"
//                                                             fill="none"
//                                                             onClick={closePriceDetails}
//                                                             xmlns="http://www.w3.org/2000/svg"
//                                                         >
//                                                             <path
//                                                                 d="M1 13L13 1"
//                                                                 stroke="#AAAAAA"
//                                                                 strokeWidth="1.2"
//                                                             />
//                                                             <path
//                                                                 d="M13 13L1 1"
//                                                                 stroke="#AAAAAA"
//                                                                 strokeWidth="1.2"
//                                                             />
//                                                         </svg>
//                                                     </div>
//                                                     <hr />
//                                                     <div>
//                                                         {(selectedAutomaticDiscount.length > 0 || selectedDiscount.length > 0) && (
//                                                             <div className="mt-10">
//                                                                 <p><b>Property Discount{selectedAutomaticDiscount?.length > 1 ? 's' : ''}</b></p>
//                                                                 {selectedAutomaticDiscount?.map((discount, index) => (
//                                                                     <div className="flex justify_content_between mt-2" key={discount.id}>
//                                                                         <span className="discount-name" style={{ color: "green" }}>{discount.promotionName}</span>
//                                                                         <span className="room_text-right green" style={{ color: "green" }}>
//                                                                             {discount.promotionMode === "percentage"
//                                                                                 ? `${+discount.promotionAmount}%`
//                                                                                 : `${formatIndianCurrency(discount.promotionAmount)}`}
//                                                                         </span>
//                                                                     </div>
//                                                                 ))}

//                                                                 {/* {selectedDiscount && selectedDiscount?.length > 0 && selectedDiscount?.map((discount, index) => (
//                           <div className="flex justify_content_between mt-2" key={discount.id}>
//                             <span className="discount-name">{discount.promotionName}</span>
//                             <span className="room_text-right green">
//                               {discount.promotionMode === "percentage"
//                                 ? `${+discount.promotionAmount}%`
//                                 : `${formatIndianCurrency(discount.promotionAmount)}`}
//                             </span>
//                           </div>
//                         ))} */}
//                                                             </div>
//                                                         )}

//                                                         <div className="agent">
//                                                             <p>
//                                                                 Room Rate <small>(Per Night)</small>
//                                                             </p>
//                                                             {/* <h6>
//                         {rooms?.automatic_discounts?.amount ? (
//                           <>
//                             <span>
//                               {formatIndianCurrency(
//                                 items?.rate_per_night
//                               )}{" "}
//                             </span>
//                           </>
//                         ) : (
//                           <h5>
//                             {formatIndianCurrency(
//                               items.rate_per_night
//                             )}
//                           </h5>
//                         )}
//                       </h6> */}

//                                                             <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
//                                                                 {(selectedAutomaticDiscount.length > 0 || selectedDiscount.length > 0) && bookingValues.newRoomRate && bookingValues.roomRateAfterDiscount && (
//                                                                     <small style={{ color: 'red', textDecoration: 'line-through' }}>
//                                                                         {formatIndianCurrency(bookingValues?.roomRatePerNight)}
//                                                                     </small>
//                                                                 )}
//                                                                 <b>
//                                                                     {formatIndianCurrency(bookingValues.roomRateAfterDiscount ? bookingValues.roomRateAfterDiscount : bookingValues.newRoomRate)}
//                                                                 </b>
//                                                             </span>
//                                                         </div>

//                                                         {(bookingData?.room > 1 ||
//                                                             noOfNights > 1) && (
//                                                                 <div className="flex justify_content_between mt-10">
//                                                                     <p>
//                                                                         {noOfNights} Night * {bookingData?.room}{" "}
//                                                                         Rooms
//                                                                     </p>
//                                                                     <span className="room_text-right">
//                                                                         {/* {formatIndianCurrency(
//                             selectedPlan?.rate_per_night *
//                             bookingData?.room *
//                             noOfNights
//                           )} */}
//                                                                         {formatIndianCurrency(
//                                                                             bookingValues?.roomRate
//                                                                         )}
//                                                                     </span>
//                                                                 </div>
//                                                             )}

//                                                         {selectedMealPlan?.extra_adult_count > 0 && (
//                                                             <div className="flex justify_content_between mt-10">
//                                                                 <p>
//                                                                     {selectedMealPlan?.extra_adult_count} Extra Adult{" "}
//                                                                     <small>
//                                                                         (
//                                                                         {formatIndianCurrency(
//                                                                             bookingValues?.extraAdultPrice
//                                                                         )}{" "}
//                                                                         * {noOfNights} Night){" "}
//                                                                     </small>{" "}
//                                                                 </p>
//                                                                 <span className="room_text-right">
//                                                                     {formatIndianCurrency(
//                                                                         bookingValues?.totalAdultCost
//                                                                     )}
//                                                                 </span>
//                                                             </div>
//                                                         )}

//                                                         {/* {bookingValues?.childPrices > 0 && (
//                       <div className="flex justify_content_between mt-10">
//                         <p>
//                           {bookingData.children} Extra Child{" "}
//                           <small>
//                             {" "}
//                             (
//                             {formatIndianCurrency(
//                               bookingValues?.childPrices
//                             )}{" "}
//                             * {noOfNights} Night){" "}
//                           </small>{" "}
//                         </p>
//                         <span className="room_text-right">
//                           {formatIndianCurrency(
//                             bookingValues?.totalChildAdultCost
//                           )}
//                         </span>
//                       </div>
//                     )} */}
//                                                         {bookingValues?.childPrices > 0 && (
//                                                             <div className="flex justify_content_between mt-10">
//                                                                 <p>
//                                                                     {extraChildrenForPricebreakup} Extra Child{" "}
//                                                                     <small>
//                                                                         {" "}
//                                                                         ({formatIndianCurrency(
//                                                                             bookingValues?.childPrices
//                                                                         )}{" "}
//                                                                         * {noOfNights} Night){" "}
//                                                                     </small>{" "}
//                                                                 </p>
//                                                                 <span className="room_text-right">
//                                                                     {formatIndianCurrency(
//                                                                         bookingValues?.totalChildAdultCost
//                                                                     )}
//                                                                 </span>
//                                                             </div>
//                                                         )}

//                                                         {complimentaryChildren > 0 && (
//                                                             <div className="flex justify_content_between mt-10">
//                                                                 <p>{complimentaryChildren} Complimentary Child</p>
//                                                                 <span className="room_text-right">Free</span>
//                                                             </div>
//                                                         )}

//                                                         {/* {bookingValues?.discountAmt > 0 && (
//           <div className="flex justify_content_between mt-10">
//             <p>Discount Amt.</p>
//             <span className="room_text-right">
//               {formatIndianCurrency(bookingValues?.discountAmt)}
//             </span>
//           </div>
//         )} */}
//                                                         {/* {bookingValues?.automaticDiscounts
//                       ?.amount && (
//                         <div className="flex justify_content_between mt-10 green">
//                           <p>
//                             Discount{" "}
//                             <small>(Automatic Discount)</small>
//                           </p>
//                           <span className="room_text-right green">
//                             {bookingValues?.automaticDiscounts
//                               ?.type === "percentage"
//                               ? `${+bookingValues
//                                 ?.automaticDiscounts?.amount}%`
//                               : `${formatIndianCurrency(
//                                 bookingValues?.automaticDiscounts
//                                   ?.amount
//                               )}`}
//                           </span>
//                         </div>
//                       )} */}

//                                                         {/* {bookingValues?.discountAmt > 0 && (
//                       <div className="flex justify_content_between mt-10">
//                         <p>
//                           Discount Amt.{" "}
//                           <small> ({noOfNights} Nights)</small>
//                         </p>
//                         <span className="room_text-right">
//                           {formatIndianCurrency(
//                             bookingValues?.discountAmt
//                           )}
//                         </span>
//                       </div>
//                     )} */}
//                                                         <div className="flex justify_content_between mt-10">
//                                                             <p>Subtotal</p>
//                                                             <span className="room_text-right">
//                                                                 {formatIndianCurrency(
//                                                                     bookingValues.subtotal
//                                                                 )}
//                                                             </span>
//                                                         </div>

//                                                         <div className="flex justify_content_between mt-10">
//                                                             <p>
//                                                                 Tax Amount ({bookingValues?.taxSlab}%)
//                                                             </p>
//                                                             <span className="room_text-right">
//                                                                 {formatIndianCurrency(
//                                                                     bookingValues.taxAmount
//                                                                 )}
//                                                             </span>
//                                                         </div>

//                                                         <div className="flex justify_content_between mt-10">
//                                                             <h6>
//                                                                 <b>Grand Total</b>
//                                                             </h6>
//                                                             <h6>
//                                                                 <b>
//                                                                     {formatIndianCurrency(
//                                                                         bookingValues?.grandTotal
//                                                                     )}
//                                                                 </b>
//                                                             </h6>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             //   <div className="flex justify_content_between mt-10">
//                                             //     <p>
//                                             //       Room Type ({bookingData?.room} R | {noOfNights} N )
//                                             //     </p>
//                                             //     <span className="room_text-right">
//                                             //       {ratesData?.room_name}
//                                             //     </span>
//                                             //   </div>

//                                             //   <div className="flex justify_content_between mt-10">
//                                             //     <p>
//                                             //       Room Rate <small>(Per Night)</small>
//                                             //     </p>
//                                             //     <span className="room_text-right">
//                                             //       {formatIndianCurrency(selectedPlan?.rate_per_night)}
//                                             //     </span>
//                                             //   </div>
//                                             //   {userDetails?.agent_category_discount && (
//                                             //     <div className="flex justify_content_between mt-10 green">
//                                             //       <p>
//                                             //         Discount % <small>(TAC)</small>
//                                             //       </p>
//                                             //       <span className="room_text-right green">
//                                             //         {Number(userDetails?.agent_category_discount)}%
//                                             //       </span>
//                                             //     </div>
//                                             //   )}

//                                             //   <div className="flex justify_content_between mt-10">
//                                             //     <p>Discount Amt.</p>
//                                             //     <span className="room_text-right">
//                                             //       {formatIndianCurrency(bookingValues?.discountAmt)}
//                                             //     </span>
//                                             //   </div>
//                                             //   <div className="flex justify_content_between mt-10">
//                                             //     <p>
//                                             //       {bookingData.children} Extra Child{" "}
//                                             //       <small>
//                                             //         {" "}
//                                             //         (
//                                             //         {formatIndianCurrency(
//                                             //           bookingValues?.childPrices
//                                             //         )}{" "}
//                                             //         * {noOfNights} Night){" "}
//                                             //       </small>{" "}
//                                             //     </p>
//                                             //     <span className="room_text-right">
//                                             //       {formatIndianCurrency(
//                                             //         bookingValues?.totalChildAdultCost
//                                             //       )}
//                                             //     </span>
//                                             //   </div>

//                                             //   <div className="flex justify_content_between mt-10">
//                                             //     <p>Subtotal</p>
//                                             //     <span className="room_text-right">
//                                             //       {formatIndianCurrency(bookingValues.subtotal)}
//                                             //     </span>
//                                             //   </div>

//                                             //   <div className="flex justify_content_between mt-10">
//                                             //     <p>Tax Amount ({bookingValues?.taxSlab}%)</p>
//                                             //     <span className="room_text-right">
//                                             //       {formatIndianCurrency(bookingValues.taxAmount)}
//                                             //     </span>
//                                             //   </div>

//                                             //   <div className="flex justify_content_between mt-10">
//                                             //     <h6>
//                                             //       <b>Grand Total</b>
//                                             //     </h6>
//                                             //     <h6>
//                                             //       <b>{formatIndianCurrency(bookingValues.grandTotal)}</b>
//                                             //     </h6>
//                                             //   </div>
//                                             // </div>
//                                         )}
//                                     </div>
//                                     <div className="single_room_price">
//                                         <div className="flex flex_gap_5 flex_wrap align_items_center">
//                                             {/* {rooms?.automatic_discounts?.type === "percentage" ? `${+rooms?.automatic_discounts?.amount}% OFF` : `${formatIndianCurrency(rooms?.automatic_discounts?.amount)} OFF`} */}
//                                             {rooms?.automatic_discounts?.amount ? (
//                                                 <>
//                                                     <span
//                                                         style={{ textDecoration: "line-through" }}
//                                                     >
//                                                         {formatIndianCurrency(items?.rate_per_night)}{" "}
//                                                     </span>
//                                                     <h4 className="Singlehotel_price">
//                                                         {rooms?.automatic_discounts?.type ===
//                                                             "percentage" ? (
//                                                             <>
//                                                                 {formatIndianCurrency(
//                                                                     items.rate_per_night -
//                                                                     (rooms?.automatic_discounts.amount /
//                                                                         100) *
//                                                                     items?.rate_per_night
//                                                                 )}
//                                                             </>
//                                                         ) : rooms?.automatic_discounts?.type ===
//                                                             "fixed" ? (
//                                                             <>
//                                                                 {formatIndianCurrency(
//                                                                     items?.rate_per_night -
//                                                                     rooms?.automatic_discounts.amount
//                                                                 )}
//                                                             </>
//                                                         ) : (
//                                                             <>
//                                                                 {formatIndianCurrency(
//                                                                     items?.rate_per_night
//                                                                 )}
//                                                             </>
//                                                         )}
//                                                     </h4>
//                                                 </>
//                                             ) : (
//                                                 <h5>
//                                                     {formatIndianCurrency(items.rate_per_night)}
//                                                 </h5>
//                                             )}
//                                             <span>+ GST</span>
//                                         </div>
//                                         <div>
//                                             {items.status === "AVAILABLE" ? (
//                                                 <>
//                                                     {items.add_rooms &&
//                                                         Number(items.required_rooms) >=
//                                                         Number(bookingData.room) ? (
//                                                         // <CustomTooltip
//                                                         //   preferredPosition="below"
//                                                         //   content={<div>{"Please Increase Rooms"}</div>}
//                                                         // >
//                                                         <button
//                                                             className="primary_btn"
//                                                             style={{
//                                                                 cursor: "not-allowed",
//                                                                 background: "grey",
//                                                                 width: "120px",
//                                                             }}
//                                                             disabled
//                                                         >
//                                                             PLEASE ADD ROOM
//                                                         </button>
//                                                     ) : (
//                                                         // </CustomTooltip>
//                                                         <button
//                                                             style={
//                                                                 {
//                                                                     // width: "90px",
//                                                                 }
//                                                             }
//                                                             onClick={() =>
//                                                                 handleSelectRoomClickHandler(
//                                                                     items,
//                                                                     cards,
//                                                                     items.room_id
//                                                                 )
//                                                             }
//                                                             className="primary_btn"
//                                                         >
//                                                             Select Rooms
//                                                         </button>
//                                                     )}
//                                                 </>
//                                             ) : (
//                                                 <>
//                                                     {items.add_rooms &&
//                                                         Number(items.required_rooms) <=
//                                                         Number(rooms) ? (
//                                                         // <CustomTooltip
//                                                         //   preferredPosition="below"
//                                                         //   content={<div>{"Please Increase Rooms"}</div>}
//                                                         // >
//                                                         <button
//                                                             className="primary_btn"
//                                                             style={{
//                                                                 cursor: "not-allowed",
//                                                                 background: "grey",
//                                                                 width: "120px",
//                                                             }}
//                                                             disabled
//                                                         >
//                                                             PLEASE ADD ROOM
//                                                         </button>
//                                                     ) : (
//                                                         // </CustomTooltip>
//                                                         <button
//                                                             className="primary_btn"
//                                                             // style={{
//                                                             //   cursor: "not-allowed",
//                                                             //   background: "grey",
//                                                             //   width: "74px",
//                                                             // }}
//                                                             // disabled
//                                                             onClick={() =>
//                                                                 handleSoldoutClickHandler(
//                                                                     items,
//                                                                     cards,
//                                                                     items.room_id
//                                                                 )
//                                                             }
//                                                         >
//                                                             Get Quote
//                                                             {/* Sold Out */}
//                                                         </button>
//                                                     )}
//                                                 </>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </div>
//         );
//     })}
// </section>
